<template>
    <tr v-for="n in rowCount" :key="n" class="static-row">
        <td v-for="y in columnCount" :key="y" class="animate-pulse">
            <div class="h-6 rounded bg-(--skeleton-bg)" style="width: 90%"></div>
        </td>
    </tr>
</template>

<script setup lang="ts">
defineProps({
    columnCount: {
        type: Number,
        required: true,
    },
    rowCount: {
        type: Number,
        default: 5,
        required: false,
    },
});
</script>
